import "./lib/maestro/login-submit-event.js";
import "./lib/maestro/logout-event.js";

import Maestro from "./lib/maestro/maestro";
import { installOptInConsentPageview } from "./lib/maestro/consent-pageview";
import { Amplitude } from "./lib/maestro/providers/amplitude-browser-sdk";
import LegacyAmplitude from "./lib/maestro/providers/legacy-amplitude";
import Klaviyo from "./lib/maestro/providers/klaviyo";

window.maestro = new Maestro(getMaestroConfig());

if (theme.amplitude.enabled) {
  if (theme.amplitude.version === "amplitude_browser_sdk") {
    window.maestro.addAnalyticsProvider(new Amplitude());
  } else if (theme.amplitude.version === "legacy_amplitude_javascript") {
    window.maestro.addAnalyticsProvider(
      new LegacyAmplitude(theme.amplitude.legacyApiKey)
    );
  }
}

window.maestro.addAnalyticsProvider(new Klaviyo());

window.maestro.purgeEventQueue();

installOptInConsentPageview();

window.maestro.addTransform("cart", (cart) => {
  return {
    "logged in": !!theme.customer.id,
    "shopify customer id": theme.customer.id ? theme.customer.id : "",
    vendor: "Our Place",
    "cart id": cart.token,
    "cart value": cart.total_price / 100,
    "product name": cart.items.map((item) => item.product_title),
    "variant name": cart.items.map((item) => item.title),
    msrp: cart.items.map((item) => item.original_price / 100),
    "product price": cart.items.map((item) => item.final_price / 100),
    "total discount": cart.items.map((item) => item.total_discount / 100),
    product_id: cart.items.map((item) => item.product_id),
    sku: cart.items.map((item) => item.sku),
    quantity: cart.items.map((item) => item.quantity),
  };
});

function getMaestroConfig() {
  let maestroConfig = {
    debug: false,
    expandLogs: false,
    preventDefault: false,
  };

  if (window.sessionStorage && URLSearchParams) {
    const searchParams = new URLSearchParams(window.location.search);
    const rawConfig = window.sessionStorage.getItem("mtr:config");

    if (rawConfig) {
      maestroConfig = {
        ...maestroConfig,
        ...JSON.parse(rawConfig),
      };
    }

    searchParams.forEach((value, key) => {
      if (key.startsWith("mtr:")) {
        maestroConfig = {
          ...maestroConfig,
          [key.replace("mtr:", "")]: /^true|1$/.test(value),
        };
      }
    });

    window.sessionStorage.setItem("mtr:config", JSON.stringify(maestroConfig));
  }

  return maestroConfig;
}

const handleKlaviyoFormsEvents = function (e) {
  const eventValue = {
    "popup text": "contest",
    formId: e.detail.formId,
  };
  const metaData = e.detail.metaData;
  if (metaData?.Variant) {
    eventValue.variant = metaData?.Variant;
  }

  if (metaData?.$source) {
    eventValue.source = metaData?.$source;
  }

  if (e.detail.type === "open") {
    window.maestro.fireTrackEvent("viewPopup", eventValue);
  }

  if (e.detail.type === "submit") {
    window.maestro.fireTrackEvent("submitPopup", eventValue);
  }
};
window.addEventListener("klaviyoForms", handleKlaviyoFormsEvents);
